import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class ToasterService {
    constructor(private _snackBar: MatSnackBar,private _translateService:TranslateService) { }
    public toastFail(message?: string): void {
        this._snackBar.open(message || this._translateService.instant("THE_OPERATION_FAILED"), null, {
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: 'red',
            duration: 6000
        });
    }
    public toastWarning(message: string): void {
        this._snackBar.open(message, null, {
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: 'yellow',
            duration: 8000
        });
    }
    public toastSuccess(message?: string): void {
        this._snackBar.open(message || this._translateService.instant("THE_OPERATION_IS_SUCCESSFUL"), null, {
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: 'green',
            duration: 3000
        });
    }
    public toastInfo(message?: string): void {
        this._snackBar.open(message || this._translateService.instant("THE_OPERATION_IS_SUCCESSFUL"), null, {
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: 'primary',
            duration: 3000
        });
    }
}
